import { Injectable } from '@angular/core';
import { IAppSession } from '../../core/model/appSessions/appSession';
import { Observable } from 'rxjs';
import { BasespaceService } from '@bssh/ng-sdk';
import { AnalysisStatus } from '../../core/model/appSessions/analysis-status';
import { delay, retryWhen } from 'rxjs/operators';
import { ApplicationCategory } from '@app/core/model/applications/application-category';
import { AppSessionPurpose } from '@app/core/model/appSessions/appsession-purpose';
import { genericRetryWhen, observableEmitDelay } from '@app/core/rxjsutils/rxjs-utilities';

export interface ICancelAnalysisService {
    canCancelAnalysis(appSessions: IAppSession[]): boolean;
    cancelAnalysis(appSession: IAppSession): Observable<IAppSession>;
}

@Injectable({
  providedIn: 'root'
})

export class CancelAnalysisService  implements ICancelAnalysisService {

    constructor(private basespaceApi: BasespaceService) { }

    /**
     * Checks if the Cancel Analysis featured is allowed on selected analyses.
     * @param appSessions The appSessions for which the check is to be made.
     */
    public canCancelAnalysis(appSessions: IAppSession[]): boolean {

        if (appSessions != null && appSessions.length > 0 && appSessions.length === 1) {
            const appSessionStatus =  appSessions[0].ExecutionStatus? AnalysisStatus[appSessions[0].ExecutionStatus].toLowerCase() : null;
            const appSessionCategory = appSessions[0].Application ? (appSessions[0].Application.Category ? appSessions[0].Application.Category.toLowerCase() : null) : null;
            const appSessionPurpose = appSessions[0].Purpose ? appSessions[0].Purpose.toLowerCase() : null;

            return (appSessionStatus === AnalysisStatus.Running.toLowerCase() ||
                appSessionStatus === AnalysisStatus.Pending.toLowerCase() ||
                appSessionStatus === AnalysisStatus.PendingExecution.toLowerCase()) &&
                (appSessionPurpose === AppSessionPurpose.DEPENDENCY_CHECKING.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.NATIVE.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.WORKFLOW.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.INSTANCE.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.WES.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.ICA_WORKFLOW_SESSION_TRACKING.toLowerCase() ||
                    appSessionCategory === ApplicationCategory.ICA_PIPELINE.toLowerCase()
                );
            }

        return false;
    }

    /**
     * Cancel the analysis/appsesion
     * @param appsesion The appsesion
     */
    public cancelAnalysis(appsesion: IAppSession) : Observable<IAppSession> {
        return this.basespaceApi.PostV2AppsessionsIdStop({id: appsesion.Id, payload: null}).pipe(
            // Retry in case of HTTP errors
            retryWhen(genericRetryWhen()),
            // To avoid a Flash of content, maintain a delay
            delay(observableEmitDelay),
        );
    }
}
